angular.module('picmonicng').factory('AudioService', [
  '$q',
  '$rootScope',
  function ($q, $rootScope) {
    return {
      analyserNode: null,
      context: null,
      recording: false,
      recorder: null,
      streamSource: null,
      hasGetUserMedia: function () {
        return !!(
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia
        );
      },
      getUserMediaObject: function () {
        return (
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.msGetUserMedia
        );
      },
      getAudioContext: function () {
        if (!this.context) {
          this.context = new (
            typeof AudioContext === 'function'
              ? AudioContext
              : typeof webkitAudioContext
              ? webkitAudioContext
              : function () {}
          )();
        }

        return this.context;
      },
      record: function () {
        var self = this;

        if (self.hasGetUserMedia()) {
          navigator.getUserMedia = self.getUserMediaObject();

          return $q(function (resolve, reject) {
            navigator.getUserMedia(
              { audio: true },
              function (mediaStream) {
                var inputPoint, audioInput, zeroGain;

                inputPoint = self.getAudioContext().createGain();

                // Create an AudioNode from the stream.
                self.streamSource = self.getAudioContext().createMediaStreamSource(mediaStream);
                audioInput = self.streamSource;
                audioInput.connect(inputPoint);

                self.analyserNode = self.getAudioContext().createAnalyser();
                self.analyserNode.fftSize = 2048;
                inputPoint.connect(self.analyserNode);

                self.recorder = new Recorder(inputPoint);

                zeroGain = self.getAudioContext().createGain();
                zeroGain.gain.value = 0.0;
                inputPoint.connect(zeroGain);
                zeroGain.connect(self.getAudioContext().destination);

                self.recorder.record();

                $rootScope.$apply(function () {
                  self.recording = true;
                });

                resolve();
              },
              function () {
                reject();
              }
            );
          });
        } else {
          return false;
        }
      },
      stop: function () {
        var self = this;
        return $q(function (resolve, reject) {
          self.recorder.stop();
          self.recorder.exportWAV(function (s) {
            resolve(s);
          });

          self.recording = false;
        });
      },
    };
  },
]);
